export default __webpack_public_path__ + "static/media/ofilsystems.27a2c87d.jpg";